import { render, staticRenderFns } from "./LocationDisabledModal.vue?vue&type=template&id=f70b5c88&scoped=true"
import script from "./LocationDisabledModal.vue?vue&type=script&lang=js"
export * from "./LocationDisabledModal.vue?vue&type=script&lang=js"
import style0 from "./LocationDisabledModal.vue?vue&type=style&index=0&id=f70b5c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70b5c88",
  null
  
)

/* custom blocks */
import block0 from "./LocationDisabledModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports